import { useContext } from "react";
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';
import { UIContext } from '../../contexts/UIContext';

import { Link } from "react-router-dom";
import { Drawer, List, ListItemButton, ListItemText, Button } from "@mui/material";
import SimpleProfileCard from '../SimpleProfileCard/SimpleProfileCard';

import LogoutIcon from '@mui/icons-material/Logout';

import './DrawerMenu.scss';

function DrawerMenu({ toggleDrawer, open }) {
  const { authUser, logout } = useContext(AuthContext);
  const {showErrorMessage} = useContext(UIContext);

  const navigate = useNavigate();
  const agentImageURL = authUser?.user?.profile_picture?.url || authUser?.user?.profile_picture;

  async function handleLogout() {
    if (!await logout()) {
      showErrorMessage({
        message: "Houve uma falha ao fazer o logout"
      });
    }
    navigate('/login');
  }

  return (
    <Drawer
      className="drawer-menu"
      anchor="left"
      open={open}
      onClose={toggleDrawer}>
      <List>
        <ListItemButton
          component={Link}
          to="/profile"
          className="agent-avatar-container">
          <div className="agent-avatar">
            <SimpleProfileCard
              className="agent-picture"
              userPictureURL={agentImageURL}
            />
            <ListItemText primary="Editar perfil" className="label" />
          </div>
        </ListItemButton>
        <ListItemButton
          component={Link}
          to="/about">
          <ListItemText primary="Sobre o app" />
        </ListItemButton>
        <ListItemButton
          component={Button}
          onClick={handleLogout}
          className="logout-label">
          <span className="logout-label">Sair</span>
          <LogoutIcon />
        </ListItemButton>
      </List>
    </Drawer>
  );
}

export default DrawerMenu;
